import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ToolSubmenu } from './ToolSubmenu';
import { searchCatalogue } from '../../Utils/sceneSearch';

export default function SceneSearchStrip({
  open,
  layout = 'row',
  modelList,
  onClose,
  onSelect,
  inputRef,
}) {
  const [query, setQuery] = useState('');
  const localRef = useRef(null);
  const ref = inputRef || localRef;

  const results = useMemo(() => searchCatalogue(modelList, query), [modelList, query]);

  useEffect(() => {
    if (open) {
      window.setTimeout(() => ref.current?.focus(), 30);
    } else {
      setQuery('');
    }
  }, [open, ref]);

  if (!open) return null;

  return (
    <ToolSubmenu layout={layout} label="Find" onClose={onClose}>
      <div className={layout === 'column' ? 'flex flex-col gap-1.5 w-full' : 'flex items-center gap-1.5 min-w-0 flex-1'}>
        <input
          ref={ref}
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Stope, hole, layer…"
          className="m-0 h-7 min-w-[10rem] flex-1 rounded-sm border border-yellow-600/30 bg-zinc-950 px-2 text-[11px] text-zinc-200 focus:border-yellow-400 focus:outline-none"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && results[0]) {
              e.preventDefault();
              onSelect?.(results[0]);
            }
          }}
        />
        <div className={layout === 'column' ? 'flex flex-col gap-0.5 w-full max-h-48 overflow-y-auto' : 'flex items-center gap-1 overflow-x-auto min-w-0'}>
          {query.trim() && results.length === 0 ? (
            <span className="text-[10px] text-zinc-500 px-1">No matches</span>
          ) : (
            results.map((item) => (
              <button
                key={item.id}
                type="button"
                className="m-0 h-7 px-2 shrink-0 rounded-sm border border-yellow-600/30 bg-zinc-950 text-[10px] uppercase tracking-wider text-yellow-400 hover:bg-yellow-500/10"
                title={`${item.group || ''} / ${item.category || ''} / ${item.layerKey}`}
                onClick={() => onSelect?.(item)}
              >
                {item.label}
              </button>
            ))
          )}
        </div>
      </div>
    </ToolSubmenu>
  );
}
